import {
  CropFieldIrrigationDto,
  GetIrrigationsResponse,
  IrrigationDto, RegisterIrrigationRequest,
  RegisterIrrigationResponse,
} from '@app/irrigations/models/api-models';
import { CropFieldWithIrrigation, Irrigation, RegisterIrrigation } from '@app/irrigations/models/models';

export const mapGetIrrigationResponse = ({ cropFields }: GetIrrigationsResponse): CropFieldWithIrrigation[] =>
  cropFields.map((cropField) => mapCropFieldIrrigationDto(cropField));

export const mapToRegisterIrrigationRequest = (registerIrrigation: RegisterIrrigation): RegisterIrrigationRequest => ({
  ...registerIrrigation,
});

export const mapRegisterIrrigationResponse = ({ cropFields }: RegisterIrrigationResponse): CropFieldWithIrrigation[] =>
  cropFields.map((cropField) => mapCropFieldIrrigationDto(cropField));

const mapCropFieldIrrigationDto = ({ id, name, irrigations }: CropFieldIrrigationDto): CropFieldWithIrrigation => ({
  id,
  name,
  irrigations: irrigations.map((i) => mapIrrigationDto(i)),
});

const mapIrrigationDto = ({ id, amountInMillimeters, startedOn, endedOn, type }: IrrigationDto): Irrigation => ({
  id,
  amountInMillimeters,
  startedOn: new Date(startedOn),
  endedOn: new Date(endedOn),
  type: type,
})
